// extracted by mini-css-extract-plugin
export default {"DeleteUser":"OrganizationSelect_DeleteUser__2UoQJ"};